import { createComponent } from '@carvana/merch-components';
import { useMemo } from 'react';
import Tag from '@/vdp/Tags/Tag';
import { RecommendedVehicle } from '~/contracts/vdp';

const Wrapper = createComponent('div', {
  className: 'm-8'
});

const TWO_HOURS = 7200;

export const usePurchaseStatus = (vehicle: RecommendedVehicle) =>
  useMemo((): {
    isLocked: boolean;
    isOnHold: boolean;
  } => {
    if (!vehicle.vehicleUnlockDateTime) {
      return { isLocked: false, isOnHold: false };
    }

    const timeLeft = vehicle.vehicleUnlockDateTime.getTime() - Date.now();

    return {
      isLocked: Math.floor(timeLeft / 1000) >= TWO_HOURS,
      isOnHold: Math.floor(timeLeft / 1000) < TWO_HOURS
    };
  }, [vehicle?.vehicleUnlockDateTime]);

const PurchasePending = () => (
  <Wrapper>
    <Tag text="Purchase Pending" bgColor="bg-red-2" />
  </Wrapper>
);
const OnHold = () => (
  <Wrapper>
    <Tag text="On Hold" bgColor="bg-yellow-3" />
  </Wrapper>
);
const LowerPrice = () => (
  <Wrapper>
    <Tag text="Lower Price" bgColor="bg-green-2" />
  </Wrapper>
);

const useBadge = (hasLowerPrice: boolean, vehicle: RecommendedVehicle) => {
  const { isLocked, isOnHold } = usePurchaseStatus(vehicle);

  return useMemo(() => {
    // purchase status takes precedence over Lower Price
    if (isLocked) return PurchasePending;
    if (isOnHold) return OnHold;
    if (hasLowerPrice) return LowerPrice;

    return null;
  }, [hasLowerPrice, isLocked, isOnHold]);
};

export default useBadge;
